<template>
    <transition
        :name="name"
        :mode="mode"
    >
        <slot />
    </transition>
</template>

<script>
export default {
    name: 'AppTransition',
    props: {
        name: {
            type: String,
            required: true,
        },
        mode: {
            type: String,
            default: 'out-in'
        },
    },
};
</script>

<style lang="scss" scoped>
  .fade-enter-active{
    transition: opacity 0.5s ease;
  }

  .fade-enter{
    opacity: 0;
  }

  .resize-enter-active{
    transition: all 0.2s;
  }

  .expand-enter-active {
    transition: height 1s ease-in-out;
    overflow: hidden;
  }

  .expand-enter{
    height: 0;
  }

  .fade-slide-enter {
      transform: scale(0.88) translateX(100px);
      opacity: 0;
  }

  .fade-slide-enter-active{
      transition:  transform 0.3s, opacity 0.5s ;
  }

  .fade-slide-enter-active{
      transition: all 0.85s ease;
  }
</style>
